import "./product-details-favorite-error-modal.scss";

export default () => {
  const $$modal = $(".js-product-details-favorite-error-modal");
  const $modalCloses = document.querySelectorAll(".js-product-details-favorite-error-modal-close");

  $modalCloses.forEach($modalClose => {
    $modalClose.addEventListener("click", () => {
      $$modal.modal("hide");
    });
  });
};
